import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default routes => {
  return new Router({
    routes,
    linkActiveClass: 'bonus-active',
    scrollBehavior (to, from, savedPosition) {
      return { x: 0, y: 0 }
    }
  })
}



// WEBPACK FOOTER //
// ./src/system/context/create-vue-router.js